module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/location-pin-nudge-a730387a024434561552f01e57925c60.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/location-pin-nudge.svg
// module id = ykaW
// module chunks = 24